import React from "react";
import { LegalLayout } from "../../components/LegalLayout";
import { LEGAL } from "../../lib/legal";

export default function Risk() {
  return (
    <LegalLayout title="Risk Disclosure" testid="legal-risk-page">
      <div className="border border-[#FF3B30]/40 bg-[#FF3B30]/5 p-4 my-6">
        <p className="text-sm text-[#FF3B30] font-[Chivo] tracking-wide">
          READ THIS DOCUMENT CAREFULLY BEFORE TRADING. TRADING SECURITIES AND CRYPTOCURRENCIES INVOLVES SUBSTANTIAL RISK
          AND IS NOT SUITABLE FOR ALL INVESTORS. YOU CAN LOSE 100% OR MORE OF YOUR INVESTED CAPITAL.
        </p>
      </div>

      <h2>1. No Investment Advice</h2>
      <p>
        {LEGAL.companyName} is <strong>not a registered investment adviser, broker-dealer, or fiduciary</strong>. Nothing
        on the Service — including AI-generated signals, charts, strategy templates, or aggregated statistics —
        constitutes investment, legal, tax, or financial advice. You are solely responsible for your trading decisions
        and outcomes.
      </p>

      <h2>2. Risk of Loss</h2>
      <p>
        Trading securities, cryptocurrencies, derivatives, and other financial instruments involves a substantial risk
        of loss. <strong>You could lose all of the funds you deposit at an exchange, and in margin or leveraged
        positions you could lose more than the amount you deposit.</strong> The vast majority of retail traders lose
        money.
      </p>

      <h2>3. High-Frequency &amp; Algorithmic Trading-Specific Risks</h2>
      <p>The Service is designed to produce a high volume of small ("micro") trades. This style introduces specific risks including:</p>
      <ul>
        <li><strong>Transaction costs:</strong> exchange fees, spreads, and slippage compound quickly and can erase any nominal profit.</li>
        <li><strong>System failures:</strong> outages, latency, internet connection issues, or exchange downtime can cause missed exits, stuck orders, or unintended exposure.</li>
        <li><strong>Market volatility:</strong> sudden price moves can cause stop-loss orders to fill far from their target price.</li>
        <li><strong>Strategy decay:</strong> a strategy that worked in backtests or paper trading may fail in live markets due to changing market conditions, liquidity, or your own size impact.</li>
        <li><strong>Software bugs:</strong> automated systems can behave unexpectedly. You are responsible for monitoring and intervening when necessary.</li>
      </ul>

      <h2>4. Cryptocurrency-Specific Risks</h2>
      <ul>
        <li>Crypto markets trade 24/7 with no circuit breakers; positions can move dramatically while you sleep.</li>
        <li>Regulatory status of cryptocurrencies and exchanges varies by jurisdiction and changes frequently.</li>
        <li>Cryptocurrency networks and exchanges can suffer hacks, forks, freezes, and insolvency.</li>
        <li>"Stablecoins" can de-peg.</li>
      </ul>

      <h2>5. Paper Trading vs. Live Trading</h2>
      <p>
        Paper-trading simulations on the Service use simulated capital and idealized fills. Live trading involves real
        money, slippage, partial fills, network latency, exchange API rate limits, fees, and many other frictions that
        simulations do not fully model. <strong>Paper performance is not predictive of live performance.</strong>
      </p>

      <h2>6. AI Signals Are Probabilistic, Not Predictive</h2>
      <p>
        AI-generated "Alpha Signals" describe statistical patterns derived from anonymized aggregate platform data and
        large-language-model reasoning. They are <strong>not predictions</strong> and do not have any guaranteed
        accuracy. Aggregate platform data may be biased, noisy, or non-representative. Treat signals as one of many
        inputs in your own research.
      </p>

      <h2>7. Tax Responsibility</h2>
      <p>
        Trading generates taxable events. You are solely responsible for tracking your gains, losses, and tax
        obligations and for filing required returns in your jurisdiction. Consult a qualified tax professional.
      </p>

      <h2>8. Suitability</h2>
      <p>
        Only trade with funds you can afford to lose entirely. Consider your financial situation, experience, objectives,
        and risk tolerance. If you do not understand a feature or risk, do not use it.
      </p>

      <h2>9. No Guarantee of Continuity</h2>
      <p>
        The Service may be modified, paused, or discontinued without notice. We are under no obligation to preserve any
        data, strategy, or feature.
      </p>

      <h2>10. Acknowledgment</h2>
      <p>
        By using the Service — and in particular by enabling Live trading mode — you acknowledge that you have read and
        understood this Risk Disclosure and accept all risks described herein. If you do not agree, do not use Live mode
        and do not provide exchange API keys.
      </p>
    </LegalLayout>
  );
}
